const createAction = (type, value) => ({
    type,
    payload: value,
});

export { createAction };
